// extracted by mini-css-extract-plugin
export default {"span2Rows":"bzMYKkKFZb0RAEJSzsdQ"};